<script setup>
import { measuringGuides } from '@/data/catalog'
import MeasuringDiagram from '@/components/MeasuringDiagram.vue'
import WhatsappButton from '@/components/WhatsappButton.vue'

defineProps({
  phone: { type: String, required: true }
})
</script>

<template>
  <section id="medir" class="bg-linen text-ink scroll-mt-16">
    <div class="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
      <header class="max-w-2xl">
        <p class="eyebrow text-glow-ink">Cómo medir</p>
        <h2 class="display mt-4 text-balance text-[clamp(1.9rem,4vw,3rem)]">
          Toma las medidas en minutos
        </h2>
        <p class="mt-4 leading-relaxed text-ink-soft">
          Con el ancho y el alto de cada ventana ya podemos cotizar. Elige qué
          cortina quieres, anota en centímetros y mándanos las medidas.
        </p>
      </header>

      <div class="mt-10 grid gap-12 lg:mt-12 lg:grid-cols-2 lg:gap-14">
        <article v-for="guide in measuringGuides" :key="guide.id">
          <div class="overflow-hidden rounded-md ring-1 ring-ink/10">
            <MeasuringDiagram :variant="guide.id" />
          </div>

          <h3 class="display mt-6 text-2xl">{{ guide.title }}</h3>
          <p class="mt-1 text-ink-soft">{{ guide.when }}</p>

          <p class="mt-4 leading-relaxed text-ink-soft">{{ guide.rule }}</p>

          <p class="mt-4 inline-block rounded-full bg-sand px-4 py-2 font-semibold text-ink">
            {{ guide.formula }}
          </p>
        </article>
      </div>

      <!-- Con la medida recién anotada, el formulario queda a un toque. WhatsApp
           se queda al lado para quien prefiere escribir. -->
      <div class="mt-12 flex flex-wrap items-center gap-x-6 gap-y-4 border-t border-ink/12 pt-8">
        <p class="w-full text-ink-soft sm:w-auto">
          ¿Con la medida en la mano?
        </p>
        <a
          href="#cotizar"
          class="inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 font-semibold text-linen transition-colors hover:bg-glow-ink"
        >
          Pedir cotización
          <span aria-hidden="true">↓</span>
        </a>
        <WhatsappButton
          :phone="phone"
          variant="outline"
          subject="cotizar una cortina, ya tengo las medidas"
          label="WhatsApp"
          source="measuring"
        />
      </div>
    </div>
  </section>
</template>
